"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPayPeriodDto = instanceOfPayPeriodDto;
exports.PayPeriodDtoFromJSON = PayPeriodDtoFromJSON;
exports.PayPeriodDtoFromJSONTyped = PayPeriodDtoFromJSONTyped;
exports.PayPeriodDtoToJSON = PayPeriodDtoToJSON;
exports.PayPeriodDtoToJSONTyped = PayPeriodDtoToJSONTyped;
/**
 * Check if a given object implements the PayPeriodDto interface.
 */
function instanceOfPayPeriodDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('minutesWorked' in value) || value['minutesWorked'] === undefined)
        return false;
    if (!('onCallMinutesWorked' in value) || value['onCallMinutesWorked'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('endDate' in value) || value['endDate'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    if (!('payrollEmployeeCheckId' in value) || value['payrollEmployeeCheckId'] === undefined)
        return false;
    if (!('stripeInvoiceId' in value) || value['stripeInvoiceId'] === undefined)
        return false;
    if (!('zealEmployeeCheckId' in value) || value['zealEmployeeCheckId'] === undefined)
        return false;
    if (!('canonicalStart' in value) || value['canonicalStart'] === undefined)
        return false;
    if (!('canonicalEnd' in value) || value['canonicalEnd'] === undefined)
        return false;
    return true;
}
function PayPeriodDtoFromJSON(json) {
    return PayPeriodDtoFromJSONTyped(json, false);
}
function PayPeriodDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'minutesWorked': json['minutesWorked'],
        'onCallMinutesWorked': json['onCallMinutesWorked'],
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'shiftId': json['shiftId'],
        'payrollEmployeeCheckId': json['payrollEmployeeCheckId'],
        'stripeInvoiceId': json['stripeInvoiceId'],
        'zealEmployeeCheckId': json['zealEmployeeCheckId'],
        'canonicalStart': (new Date(json['canonicalStart'])),
        'canonicalEnd': (new Date(json['canonicalEnd'])),
    };
}
function PayPeriodDtoToJSON(json) {
    return PayPeriodDtoToJSONTyped(json, false);
}
function PayPeriodDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'minutesWorked': value['minutesWorked'],
        'onCallMinutesWorked': value['onCallMinutesWorked'],
        'startDate': ((value['startDate']).toISOString()),
        'endDate': ((value['endDate']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'shiftId': value['shiftId'],
        'payrollEmployeeCheckId': value['payrollEmployeeCheckId'],
        'stripeInvoiceId': value['stripeInvoiceId'],
        'zealEmployeeCheckId': value['zealEmployeeCheckId'],
        'canonicalStart': ((value['canonicalStart']).toISOString()),
        'canonicalEnd': ((value['canonicalEnd']).toISOString()),
    };
}
//# sourceMappingURL=PayPeriodDto.js.map